module.exports = __webpack_public_path__ + "static/media/close.502f272c.svg";